// src/routes.js
import React from "react";
import { Route } from "react-router-dom";
import Layout from "../pages/Layout/BasicLayout"; // Layout for wrapping around pages
import Login from "../pages/NewLoginTemp/Login"; // Login page
import OtpVerification from "../pages/NewLoginTemp/OtpVerification"; // OTP Verification page
import ForgotPassword from "../pages/NewLoginTemp/ForgotPassword";
import ChangePassword from "../pages/NewLoginTemp/ChangePassword";
import TemporaryPassword from "../pages/NewLoginTemp/TemporaryPassword";

// You can define your routes here as an array of objects
const routes = [
  {
    path: "/",
    element: <Login />,
    layout: Layout,
    exact: true,
    name: "Login",
  },
  {
    path: "/otp-verification",
    element: <OtpVerification />,
    layout: Layout,
    exact: true,
    name: "OTP Verification",
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
    layout: Layout,
    exact: true,
    name: "Forgot Password",
  },
  {
    path: "/change-password",
    element: <ChangePassword />,
    layout: Layout,
    exact: true,
    name: "Change Password",
  },
  {
    path: "/temp-password",
    element: <TemporaryPassword />,
    layout: Layout,
    exact: true,
    name: "Temporary Password",
  },
];

export default routes;
